import { inject, Injectable } from '@angular/core';
import Intercom, { hide } from '@intercom/messenger-js-sdk';
import { CustomerChatbotService } from './types';
import { AzavistaApiService, ITokenPayload, IUser } from '@azavista/servicelib';

const INTERCOM_APP_ID = 'rmafpc15';

@Injectable({
    providedIn: 'root',
})
export class IntercomCustomerChatbotService extends CustomerChatbotService {
    apiSvc = inject(AzavistaApiService);
    private readonly querySelectorValue = '.intercom-launcher';

    async showChatbot() {
        this.toggleHideButton(false);
    }

    async hideChatbot() {
        hide();
        this.toggleHideButton(true);
    }

    private toggleHideButton(hide: boolean) {
        const intercomButton = document.querySelector<HTMLElement>(this.querySelectorValue);
        if (intercomButton) {
            if (hide) {
                intercomButton.style.display = 'none';
            } else if (intercomButton.style.display === 'none') {
                intercomButton.style.removeProperty('display');
            }
        }
    }

    async initUserSession(user: IUser, token: ITokenPayload): Promise<void> {
        const { email, id: user_id, first_name, last_name } = user;
        const { c: customer_id } = token;
        const customer = await this.apiSvc.getCustomer();
        Intercom({
            app_id: INTERCOM_APP_ID,
            email,
            company: {
                company_id: `${customer_id}`,
                name: customer?.name || '',
            },
            user_id: `${user_id}`,
            name: `${first_name} ${last_name}`.trim(),
        });
    }
    async endUserSession(): Promise<void> {
        await this.initUnAuthenticatedUser();
    }
    async initUnAuthenticatedUser() {
        Intercom({
            app_id: INTERCOM_APP_ID,
        });
    }
}
